import MeterUnitTariff from "../../../utils/services/project/metering/meterUnitTariffService";
import crudTemplate from "../../../templates/crudTemplate";
let crud = crudTemplate(MeterUnitTariff);
function prepareItem(i, filter_types) {
  if (i._tariff) {
    i.id = i._tariff.id;
    i.tariff_name = i._tariff.name;
  }
  if (i._ingestion.filter_type) {
    let filter_type = filter_types.find(
      u => u.value === i._ingestion.filter_type
    );
    i.filter_text = filter_type && filter_type.text;
  }
  return i;
}
const state = {
  ...crud.state
};
const getters = {
  ...crud.getters,
  getList(state, getters, rootState, rootGetters) {
    let list = crud.getters.getList(state);
    let filter_types =
      rootGetters["projectMeteringStore/ingestionStore/getFilterTypes"];
    return (list && list.map(i => prepareItem(i, filter_types))) || [];
  }
};

const actions = {
  ...crud.actions
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
